import React, { useContext, useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { Button } from "@components/buttons";
import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";

export const AutoSellConfirmationFooter = observer(
	function AutoSellConfirmationFooter() {
		const [shouldSaveButtonBeDisabled, setShouldSaveButtonBeDisabled] =
			useState<boolean>(false);
		const [shouldDeleteButtonBeDisabled, setShouldDeleteButtonBeDisabled] =
			useState<boolean>(false);

		const { t } = useTranslation();

		const store = useContext(BetDetailsModalStoreContext);

		let cashoutStore: CashoutStore;

		if (store instanceof BetDetailsModalStore) {
			cashoutStore = store.myBetsStore.cashoutStore;
		} else {
			cashoutStore = store.cashoutStore;
		}

		if (!store) {
			console.error("Expected store, got null");
			return null;
		}
		if (cashoutStore.isAutosellModalCashedOut) {
			return (
				<button
					type="button"
					className="popup__btn popup__btn--secondary btn btn--med btn--primary--inverted"
					onClick={() => {
						cashoutStore.closeAutosellModalBetDetails();
						store.onAutoSellClose();
					}}
				>
					{t("COMMON.CLOSE")}
				</button>
			);
		} else if (cashoutStore.isAutocashoutUnavailable) {
			return (
				<>
					{cashoutStore.isConfigurationExists && (
						<button
							type="button"
							className="popup__btn popup__btn--destructive btn btn--med btn--primary--inverted u-color--sent--danger"
							disabled
						>
							{t("COMMON.DELETE")}
						</button>
					)}

					<button
						type="button"
						className="popup__btn popup__btn--secondary btn btn--med btn--primary--inverted"
						onClick={() => {
							cashoutStore.closeAutosellModalBetDetails();
							store.onAutoSellClose();
						}}
					>
						{t("COMMON.CLOSE")}
					</button>

					<button
						type="button"
						className="popup__btn popup__btn--primary btn btn--med btn--accent"
						onClick={async () => {
							if (cashoutStore.openedAutosellModalBetSlipId) {
								await cashoutStore.setSecureWinConfiguration(
									cashoutStore.openedAutosellModalBetSlipId,
									Number(cashoutStore.secureWinAmount)
								);
								store.onAutoSellClose();
							}
						}}
						disabled={cashoutStore.isSaveBtnDisabled}
					>
						{t("COMMON.SAVE")}
					</button>
				</>
			);
		} else {
			return (
				<>
					{cashoutStore.isConfigurationExists && (
						<Button
							type="button"
							className="popup__btn popup__btn--destructive btn btn--med btn--primary--inverted u-color--sent--danger"
							onClick={async () => {
								setShouldDeleteButtonBeDisabled(true);
								if (cashoutStore.openedAutosellModalBetSlipId) {
									await cashoutStore.removeSecureWinConfiguration(
										cashoutStore.openedAutosellModalBetSlipId
									);
									store.onAutoSellClose();
								}
								setShouldDeleteButtonBeDisabled(false);
							}}
							disabled={shouldDeleteButtonBeDisabled}
							btnText={t("COMMON.DELETE")}
						></Button>
					)}

					<button
						type="button"
						className="popup__btn popup__btn--secondary btn btn--med btn--primary--inverted"
						onClick={() => {
							cashoutStore.closeAutosellModalBetDetails();
							store.onAutoSellClose();
						}}
					>
						{t("COMMON.CANCEL")}
					</button>

					<Button
						type="button"
						className="popup__btn popup__btn--primary btn btn--med btn--accent"
						onClick={async () => {
							setShouldSaveButtonBeDisabled(true);
							if (cashoutStore.openedAutosellModalBetSlipId) {
								await cashoutStore.setSecureWinConfiguration(
									cashoutStore.openedAutosellModalBetSlipId,
									Number(cashoutStore.secureWinAmount)
								);

								store.onAutoSellClose();
							}
							setShouldSaveButtonBeDisabled(false);
						}}
						disabled={
							cashoutStore.isSaveBtnDisabled ||
							shouldSaveButtonBeDisabled
						}
						btnText={t("COMMON.SAVE")}
					></Button>
				</>
			);
		}
	}
);
